import axios from 'axios';
import { apiUrl } from '../apiUrl/ApiUrl';

const apiClient = axios.create({
  baseURL: apiUrl,
});

apiClient.interceptors.request.use(
  (config) => {
    const company = sessionStorage.getItem('company') || 'FM';
    const userId = sessionStorage.getItem('Id');
    const token = sessionStorage.getItem('token');

    config.headers['X-Company'] = company;

    if (userId) {
      // 舊程式如果還在讀 Request.Headers["Id"]，先保留
      config.headers.Id = userId;

      // 新寫法建議用這個
      config.headers['X-User-Id'] = userId;
    }

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;

    if (status === 401) {
      sessionStorage.clear();

      if (window.location.pathname !== '/login') {
        window.location.replace('/login');
      }
    }

    // 403 代表已登入但權限不足，不應清除登入狀態。

    return Promise.reject(error);
  }
);

export default apiClient;
